"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogEngagementEventRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class LogEngagementEventRequestDto {}
exports.LogEngagementEventRequestDto = LogEngagementEventRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.EngagementEventType
}), __metadata("design:type", String)], LogEngagementEventRequestDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Required for hotspot_* events.'
}), __metadata("design:type", String)], LogEngagementEventRequestDto.prototype, "partneredHotspotPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Required for get_tickets_tapped; defaults to the hotspot event for hotspot_* events.'
}), __metadata("design:type", String)], LogEngagementEventRequestDto.prototype, "eventPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.EventSource,
  required: false,
  description: 'Where the event screen was opened from (get_tickets_tapped).'
}), __metadata("design:type", String)], LogEngagementEventRequestDto.prototype, "source", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Client time of the action (ISO 8601). Defaults to the server receive time.'
}), __metadata("design:type", String)], LogEngagementEventRequestDto.prototype, "occurredAt", void 0);
//# sourceMappingURL=LogEngagementEventRequest.dto.js.map